import optionsApi from "./optionsApi";

export type OptionsSession = { userId: string; defaultCompanyId: string };

export async function getOptionsSession(
  token: string
): Promise<OptionsSession> {
  const response = await optionsApi.get<OptionsSession>("/v1/auth/session", {
    headers: { Authorization: token },
  });
  return response.data;
}
